<ng-container *transloco="let t">
  <div class="flex flex-col gap-5">
    <div class="my-5 flex items-center gap-2">
      <div class="inline-flex items-center gap-2">
        <IToggle
          [checked]="displayEventAnnotation()"
          (checkedChange)="displayEventAnnotation.set(!displayEventAnnotation())"
        />
        <span>{{ t("dashboard.activity_events") }}</span>
      </div>
      @if (displayEventAnnotation()) {
        <app-activity-event-filters
          [displayEventAnnotation]="true"
          [allEventAnnotationTypes]="allEventAnnotationTypes"
        />
      }
    </div>
  </div>
  <app-metric-selector
    [data]="totalStats()"
    [previousPeriodData]="previousTotalStats()"
    [localStorageKey]="localStorageKey"
    [availableMetrics]="METRICS"
    (selectedMetricsChange)="selectMetric($event)"
  />

  <IChart [config]="chartConfig()" [data]="chartData()" />

  <div class="ag-theme-quartz w-full">
    <div class="h-[30rem]">
      <ag-grid-angular [gridOptions]="gridOptions()" [rowData]="rowStats()" class="h-full w-full" />
    </div>
  </div>
</ng-container>

<ng-template #creativeStatsDetailsModal>
  @if (tacosStrategy().sbStrategy) {
    <div class="ag-theme-quartz mt-3 h-[45rem] w-[min(95vw,70rem)]">
      <app-sb-creative-stats-grid [strategy]="tacosStrategy().sbStrategy" [currency]="currency()" [locale]="locale()" />
    </div>
  }
</ng-template>
